import { v4 as uuidv4 } from 'uuid';

const generate = () => `anon_${uuidv4()}`;

export { generate };
